/* eslint-disable no-useless-catch */
import GenerateRequest from './resources';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest();

export default {
  async getEmbedToken() {
    try {
      await checkLicenseExpiry();
      const { data } = await req.get('dashboard/getBIToken');
      return data;
    } catch (e) {
      throw e;
    }
  },
};
